export default function CsharpWhile() {
  return (
    <h2>Csharp While</h2>
  );
}
